import React, { useState, useEffect, useRef, useCallback } from 'react';

import { 
  Character,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterClassInput from "@dndComponents/character/classes/CharacterClassInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  character: Character;
  disabled: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterClassButton({
  character,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);
  const [flashing, setFlashing] = useState(character.classes.length === 0 || character.classes.filter(o => o.needs_attention).length > 0);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setTimeout(() => {
      setFlashing(character.classes.length === 0 || character.classes.filter(o => o.needs_attention).length > 0);
      setReloading(true);
    }, 100);
  }, []);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  }, [character, recalculated]);

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        width={ wide_mode ? 800 : undefined }
        full_page
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open ?
          <CharacterClassInput
            character={character}
          />
        : <></>
        }
      </ModalOrDrawer>
    );
  }
  const className = flashing ? "Flashing clickable" : "clickable";
  return (
    <>
      <div style={{ fontSize: "16px" }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        { character.classes.length === 0 ? 
          "No Class"
        : character.classes.length === 1 ? `${char_util.getUseName(character.classes[0])} ${character.classes[0].level}`
        : character.classes.sort((a, b) => (a.position > b.position ? 1 : -1)).map(char_class => `${char_class.source && char_class.source.get_use_name()} ${char_class.level}`).join(" / ") }
      </div>
      <div style={{ 
          fontSize: "10px", 
          color: "gray",
        }}
        className={ disabled ? "" : className }
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        Class{ character.classes.length !== 1 && <span>es</span> }
      </div>
      { renderExtras() }
    </>
  ); 
}
